module.exports = __webpack_public_path__ + "img/23.ca9545ab.jpg";